import React, { useMemo } from 'react';
import { useMovieSearch } from '../hooks/useMovie';
import { usePageTitle } from '../hooks/usePageTitle';
import { toTitles, slugify } from '../lib/catalogue';
import { MovieSpotlight } from '../components/movie-spotlight';
import { MoviesView } from '../components/movies-view';
import { SubscribeBand } from '../components/subscribe-band';

export default function MoviesPage() {
  usePageTitle(
    'Movies · Kast',
    'Stream the complete movie collection on Kast. Explore genres, watch trailers, and stream features.'
  );
  const { data: results = [], isLoading } = useMovieSearch('', undefined);

  const movies = useMemo(() => {
    const list = Array.isArray(results) ? results : results?.data || [];
    return toTitles(list).filter((t) => !t.isSeries);
  }, [results]);

  const featured = movies.length > 0 ? movies[0] : null;

  const genres = useMemo(() => {
    const counts = new Map();
    for (const movie of movies) {
      const name = movie.category || 'Other';
      counts.set(name, (counts.get(name) || 0) + 1);
    }
    return [...counts.entries()].map(([name, count]) => ({
      id: slugify(name) || name,
      name,
      count,
    }));
  }, [movies]);

  return (
    <div className="flex flex-col min-h-screen">
      {isLoading ? (
        <div className="w-full min-h-[65vh] sm:min-h-[72vh] lg:min-h-[78vh] bg-card/20 animate-pulse" />
      ) : (
        <MovieSpotlight movie={featured} />
      )}

      <MoviesView movies={movies} genres={genres} />

      <SubscribeBand />
    </div>
  );
}
